"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MockedCapturePlusApi = /** @class */ (function () {
    function MockedCapturePlusApi() {
    }
    MockedCapturePlusApi.prototype.retrieve = function (id) {
        var _this = this;
        return new Promise(function (resolve) {
            resolve(_this.getSampleDataForRetrieve(id));
        });
    };
    MockedCapturePlusApi.prototype.find = function (query, lastId) {
        var _this = this;
        return new Promise(function (resolve) {
            var results = _this.getSampleDataForFind(query);
            resolve(results);
        });
    };
    MockedCapturePlusApi.prototype.getSampleDataForFind = function (query) {
        var sampleData = [
            {
                Cursor: 0,
                Description: 'Royal Mail, 185 Farringdon Road, London',
                Highlight: '',
                Id: '53166608',
                Next: 'Retrieve',
                Text: 'EC1A 1AA'
            },
            {
                Cursor: 2,
                Description: 'Flat 4124 Little Paris, 17 The Avenue, London',
                Highlight: '',
                Id: '412434545',
                Next: 'Retrieve',
                Text: 'SE15EA'
            },
            {
                Cursor: 3,
                Description: 'Flat 412324 Little Paris, 17 The Avenue, London',
                Highlight: '',
                Id: '412324565',
                Next: 'Retrieve',
                Text: 'SE15EA'
            },
            {
                Cursor: 4,
                Description: '33 St Mary Axe, London',
                Highlight: '',
                Id: '3435545',
                Next: 'Retrieve',
                Text: 'EC3A 8AG'
            }
        ];
        var results = sampleData.filter(function (item) {
            return item.Text.includes(query);
        });
        return { ContainerCount: results.length, Items: results };
    };
    MockedCapturePlusApi.prototype.getSampleDataForRetrieve = function (id) {
        var sampleData = {
            53166608: {
                Items: [
                    {
                        AdminAreaName: 'Islington',
                        Barcode: '(EC1A1AA1AT)',
                        BuildingNumber: '185',
                        City: 'London',
                        Company: 'Royal Mail',
                        CountryIso2: 'GB',
                        CountryIso3: 'GBR',
                        CountryIsoNumber: '826',
                        CountryName: 'United Kingdom',
                        DataLevel: 'Premise',
                        DomesticId: '53166608',
                        Id: 'GB|RM|A|53166608',
                        Label: 'Royal Mail, 185 Farringdon Road, London',
                        Language: 'ENG',
                        LanguageAlternatives: 'ENG',
                        Line1: '185 Farringdon Road',
                        PostalCode: 'EC1A 1AA',
                        SortingNumber1: '74116',
                        Street: 'Farringdon Road',
                        Type: 'Commercial'
                    },
                ]
            },
            412434545: {
                Items: [
                    {
                        BuildingName: 'Little Paris',
                        BuildingNumber: '17',
                        City: 'London',
                        CountryIso2: 'GB',
                        CountryIso3: 'GBR',
                        CountryIsoNumber: '826',
                        CountryName: 'United Kingdom',
                        DataLevel: 'Premise',
                        DomesticId: '412434545',
                        Id: 'GB|RM|A|412434545',
                        Label: 'Flat 4124 Little Paris, 17 The Avenue, London',
                        Language: 'ENG',
                        LanguageAlternatives: 'ENG',
                        Line1: 'Flat 4124 Little Paris',
                        Line2: '17 The Avenue',
                        PostalCode: 'SE15EA',
                        SortingNumber1: '74116',
                        Street: 'The Avenue',
                        Type: 'Residential'
                    },
                ]
            },
            412324565: {
                Items: [
                    {
                        BuildingName: 'Little Paris',
                        BuildingNumber: '17',
                        City: 'London',
                        CountryIso2: 'GB',
                        CountryIso3: 'GBR',
                        CountryIsoNumber: '826',
                        CountryName: 'United Kingdom',
                        DataLevel: 'Premise',
                        DomesticId: '412324565',
                        Id: 'GB|RM|A|412324565',
                        Label: 'Flat 412324 Little Paris, 17 The Avenue, London',
                        Language: 'ENG',
                        LanguageAlternatives: 'ENG',
                        Line1: 'Flat 412324 Little Paris',
                        Line2: '17 The Avenue',
                        PostalCode: 'SE15EA',
                        SortingNumber1: '74116',
                        Street: 'The Avenue',
                        Type: 'Residential'
                    },
                ]
            },
            3435545: {
                Items: [
                    {
                        BuildingNumber: '33',
                        City: 'London',
                        Company: 'Deko',
                        CountryIso2: 'GB',
                        CountryIso3: 'GBR',
                        CountryIsoNumber: '826',
                        CountryName: 'United Kingdom',
                        DataLevel: 'Premise',
                        DomesticId: '3435545',
                        Id: 'GB|RM|A|3435545',
                        Label: '33 St Mary Axe, London',
                        Language: 'ENG',
                        LanguageAlternatives: 'ENG',
                        Line1: 'Deko',
                        Line2: '33 St Mary Axe, London',
                        PostalCode: 'EC3A 8AG',
                        SortingNumber1: '74116',
                        Street: 'St Mary Axe',
                        Type: 'Commercial'
                    },
                ]
            }
        };
        return (sampleData[id]) ? sampleData[id] : null;
    };
    return MockedCapturePlusApi;
}());
exports.default = MockedCapturePlusApi;
